import decoder from '../../../lib/decoder';

function ModelNumber() {
	this.id = 0;
	this.formatted = '';
	this.selected = false;
	this.error = false;
	this.html = {};
}

ModelNumber.prototype.htmlFormatted = function (patterns) {
	if (!Array.isArray(patterns)) {
		patterns = [];
	}
	
	let patternsCount = patterns.length;
	
	let cacheKey = 'default';
	if (patternsCount > 0) {
		cacheKey = JSON.stringify(patterns);
	}
	
	if (!this.html[cacheKey]) {
		let index = this.formatted.indexOf(')') + 1;
		let numberWithoutCode = this.formatted.substr(index).trim();
		
		if (patternsCount > 0) {
			let numberOnlyDigits = '';
			let delimiterIndex = {};
			let digitsCount = 0;
			for (let i = 0, l = numberWithoutCode.length; i < l; i ++) {
				let char = numberWithoutCode.charAt(i);
				if (char === '-') {
					delimiterIndex[digitsCount] = true;
				} else {
					numberOnlyDigits += char;
					digitsCount++;
				}
			}
			
			let highlightIndex = {};
			let hasHighlights = false;
			let regex = new RegExp(patterns.join('|'), 'g');
			let groupsCount = (new RegExp(regex.toString() + '|')).exec('').length - 1;
			numberOnlyDigits.replace(regex, function(match) {
				for (let i = arguments[groupsCount + 1], l = i + match.length; i < l; i++) {
					highlightIndex[i] = true;
				}
				hasHighlights = true;
				return match;
			});
			
			if (hasHighlights) {
				numberWithoutCode = '';
				for (let i = 0, l = numberOnlyDigits.length; i < l; i ++) {
					let char = numberOnlyDigits.charAt(i);
					
					if (delimiterIndex[i] === true) {
						numberWithoutCode += '-';
					}
					
					if (highlightIndex[i] === true) {
						numberWithoutCode += '<i>' + char + '</i>';
					} else {
						numberWithoutCode += char;
					}
				}
			}
		}
		
		this.html[cacheKey] = '<span>' + this.formatted.substr(0, index) + '</span> ' + numberWithoutCode;
	}
	
	return this.html[cacheKey];
};

ModelNumber.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelNumber();
	
	model.id = decoder.intValue(json['id'], 0);
	model.formatted = decoder.stringValue(json['formatted'], '');
	
	return model;
};

export default ModelNumber;